import i18n from "@/libs/i18n/i18n";

export const initialState = {
  services: [],
  serviceCategories: [],
  femaleSurgeriesService: [],
  maleSurgeriesService: [],
  femaleSonographiesService: [],
  maleSonographiesService: [],
  serviceToEdit:null,
  categories: [],
  properties: [],
  category: "",
  title: "",
  code: null,
  status: "",
  property: "",
  total:"",
  serviceInsurances: [{
    insuranceId: "",
    k: {
      professional: 0,
      technical: 0,
      anesthesia: 0,
      other: 0,
    },
  }],
  discountGroups:[],
  serviceGroups:[],
  serviceGenders:  [
    { value: "female", text: i18n.t("general.female") },
    { value: "male", text: i18n.t("general.male") },
    { value: "both", text: i18n.t("general.both") },
  ],
  serviceGender: 'both',
  mriServices:[],
  ctScanServices:[],
  labServices:[],
  }